// Shared notification state for bell + Today attention strip (single 45s poll).
import { createContext, useContext, type ReactNode } from "react";
import { useNotifications } from "../lib/use-notifications";

type NotifApi = ReturnType<typeof useNotifications>;

const Ctx = createContext<NotifApi | null>(null);

export function NotificationsProvider({ children }: { children: ReactNode }) {
  const api = useNotifications();
  return <Ctx.Provider value={api}>{children}</Ctx.Provider>;
}

export function useNotificationsContext(): NotifApi {
  const v = useContext(Ctx);
  if (!v) throw new Error("useNotificationsContext requires NotificationsProvider");
  return v;
}
